// extracted by mini-css-extract-plugin
module.exports = {"totalPrice":"_1OlC4-","scentPrice":"_258cCh","option":"_2bi3Du","prices":"_2IdxBD"};